function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "100",
  height: "100",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("title", null, "icon-delete"), React.createElement("g", {
  id: "icon-trash-icon-delete",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M66.7414547,13.2794213 L96.6477124,13.2794213 L96.6477124,20.4492042 L86.9498507,20.4492042 L80.8756022,100 L18.6038058,100 L12.5295572,20.4492042 L4,20.4492042 L4,13.2794213 L32.5089656,13.2794213 L32.5089656,-5.68434189e-14 L66.7414547,-5.68434189e-14 L66.7414547,13.2794213 Z M59.7316279,7.05063125 L39.6332862,7.05063125 L39.6332862,13.1600346 L59.7316279,13.1600346 L59.7316279,7.05063125 Z M25.0294804,92.7105953 L74.0982679,92.7105953 L79.707064,20.3241772 L19.539384,20.3241772 L25.0294804,92.7105953 Z M46.0577925,30.6715737 L53.186319,30.6715737 L53.186319,82.7281743 L46.0577925,82.7281743 L46.0577925,30.6715737 Z M66.2753012,82.9432114 L59.1605607,82.5530542 L61.9717349,30.4600266 L69.0864755,30.8501838 L66.2753012,82.9432114 Z M32.9610994,82.9432114 L30.1544816,30.8501838 L37.2692221,30.4646211 L40.0758399,82.5576487 L32.9610994,82.9432114 Z",
  id: "icon-trash-Combined-Shape",
  fill: "#000",
  fillRule: "nonzero"
}))));